import { bookLoaded } from "../action-types";

const fetchBook = async( dispatch ) =>{
    const responce = await fetch('http://localhost:9000/books');

    const book = await responce.json();

    dispatch(bookLoaded(book))
}

export default fetchBook;